import { z } from 'zod';

const verifyEmailSchema = z.object({
   otp: z
      .string()
      .min(1, 'OTP is required')
      .min(6, 'OTP must be 6 digits')
      .max(6, 'OTP must be 6 digits')
      .transform(val => Number(val))
      .refine(val => !isNaN(val), {
         message: 'OTP must be a 6 digits number',
      })
      .transform(val => val.toString()),
});

export type TVerifyEmail = z.infer<typeof verifyEmailSchema>;
export { verifyEmailSchema };
